import clsx from "clsx";
import React from "react";
import { LayoutMargins, LayoutWidth, MediaSpecific, marginsClassMSL, mediaSpecificClassSWL, widthClass } from "../Layout";
import { Color, ColorType, colorClass } from "../Typography";
import { CardVariant } from "./Card";
import styles from "./card.module.scss";

interface CardTextLayout extends LayoutMargins, LayoutWidth
{
    variant?: CardVariant;
}

interface CardTextProps extends React.ComponentProps<"div">
{
    layout?: MediaSpecific<CardTextLayout>;
    textColor?: Color;
}

export const CardText = ({ className, layout, textColor, ...props }: CardTextProps): React.ReactComponentElement<"div", CardTextProps> =>
{
    const classes = clsx(
        styles["text"],
        colorClass(textColor, ColorType.Text),
        marginsClassMSL(layout),
        widthClass(layout),
        mediaSpecificClassSWL("column", layout, "variant", CardVariant.Column, c => styles[c]),
        mediaSpecificClassSWL("column-reversed", layout, "variant", CardVariant.ColumnReversed, c => styles[c]),
        mediaSpecificClassSWL("column-space-between", layout, "variant", CardVariant.ColumnSpaceBetween, c => styles[c]),
        mediaSpecificClassSWL("column-reversed-space-between", layout, "variant", CardVariant.ColumnReversedSpaceBetween, c => styles[c]),
        mediaSpecificClassSWL("row", layout, "variant", CardVariant.Row, c => styles[c]),
        mediaSpecificClassSWL("row-reversed", layout, "variant", CardVariant.RowReversed, c => styles[c]),
        mediaSpecificClassSWL("row-space-between", layout, "variant", CardVariant.RowSpaceBetween, c => styles[c]),
        mediaSpecificClassSWL("row-reversed-space-between", layout, "variant", CardVariant.RowReversedSpaceBetween, c => styles[c]),
        className,
    );

    return <div {...props} className={classes} />;
}